// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__9HIEB","iframe-outer":"styles-m__iframe-outer__3OoIn","iframe-container":"styles-m__iframe-container__1dYLP"};